import Query from '../Query';

export default function ContentType(query: Query): Query {
  const contentType = query.serializer.contentType();

  if (contentType) {
    query.addHeader('Content-Type', contentType);
  }

  return query;
}
